import { getTenantId } from 'src/app/services/store-snapshot.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { IdName } from '../../shared/models/id-name';
import { ICompetenceGroupModel } from '../model/competence-group.model';

@Injectable({
  providedIn: 'root',
})
export class CompetenceGroupApiService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Competence/Groups`;
  }

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  getCompetenceGroups(
    includeDeleted: boolean,
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<ICompetenceGroupModel[]>> {
    let params = createFilterParams(currentFilter);
    params = params.set('includeDeleted', includeDeleted);

    return this.http.get<ApiResponse<ICompetenceGroupModel[]>>(this.baseUrl, {
      ...this.httpOptions,
      params,
    });
  }

  getAllCompetenceGroups(): Observable<IdName[]> {
    const url = `${this.baseUrl}/List`;
    return this.http.get<IdName[]>(url, this.httpOptions);
  }

  addCompetenceGroup(competenceGroup: ICompetenceGroupModel): Observable<ICompetenceGroupModel> {
    const url = `${this.baseUrl}`;
    return this.http.post<ICompetenceGroupModel>(url, competenceGroup, this.httpOptions);
  }

  getCompetenceGroupById(id: string): Observable<ICompetenceGroupModel> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<ICompetenceGroupModel>(url, this.httpOptions);
  }

  updateCompetenceGroup(competenceGroup: ICompetenceGroupModel): Observable<ICompetenceGroupModel> {
    const url = `${this.baseUrl}/${competenceGroup.id}`;
    return this.http.put<ICompetenceGroupModel>(url, competenceGroup, this.httpOptions);
  }

  deleteCompetenceGroup(id: string): Observable<void> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete<void>(url, this.httpOptions);
  }

  restoreCompetenceGroup(id: string): Observable<void> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.patch<void>(url, this.httpOptions);
  }
}
